/** 保留受支持的身份流程入口，登录后继续授权或确认，不跳到其他业务首页。 */
export function loginPathForPage(pathname: string, search: string): string {
  if (pathname === '/user/login') return pathname + search;
  const returnToPage =
    pathname.startsWith('/mcp/') ||
    pathname === '/user/change-password' ||
    [
      '/account/ai-authorizations',
      '/system/mcp',
      '/third-platform/work-wx/native-payment',
    ].includes(pathname);
  return returnToPage
    ? `/user/login?redirect=${encodeURIComponent(pathname + search)}`
    : '/user/login';
}
